module.exports = __webpack_public_path__ + "static/media/ally-II-ups-image@3x.03956f51.png";